import { z } from 'zod';
import { transformAndFilterValidItems } from '../../../common/tools/transformUtils';

export const DistributorSchema = z
    .object({
        id: z.string(),
        key: z.string(),
        name: z.string(),
        isGlobal: z.boolean(),
        isFeatured: z.boolean(),
        url: z.string().nullable(),
        phone: z.string().nullable(),
        logo: z
            .object({
                fullpath: z.string(),
            })
            .nullable()
            .optional(),
        countries: z
            .array(z.unknown())
            .transform((countries) =>
                transformAndFilterValidItems(
                    z.object({
                        id: z.string(),
                    }),
                    countries
                )
            )
            .nullable(),
        text: z.string().nullable(), // Ensure freeFormText is nullable
    })
    .describe('DistributorSchema')
    .refine(
        (data) => {
            // If isGlobal is true, countries must be null or empty.
            if (data.isGlobal) {
                return !data.countries || data.countries.length === 0;
            } else {
                // Allow countries to be null or empty for flexibility, e.g. for using the distributor
                // as logo provider for Octopart; these won't be displayed in lists.
                return true;
            }
        },
        {
            message: 'Invalid countries configuration based on isGlobal flag',
        }
    );

export const GetDistributorsListingSchema = z
    .object({
        getObjectFolder: z.object({
            children: z
                .array(z.unknown())
                .transform((distributors) =>
                    transformAndFilterValidItems(DistributorSchema, distributors)
                ),
        }),
    })
    .describe('GetDistributorsListingSchema');
